import { comics } from "@/mocks/comics";
import { comicPanels } from "@/mocks/comicPanels";
import type { Comic, ComicChapter } from "@/types/comic";

export function getComicById(id: string): Comic | undefined {
  return (comics as Comic[]).find((comic) => comic.id === id);
}

export function getChapter(
  comic: Comic | undefined,
  chapterId: string
): ComicChapter | undefined {
  if (!comic) return undefined;
  return comic.chapters.find((chapter) => chapter.id === chapterId);
}

export function getChapterImages(comicId: string, chapterId: string): string[] {
  const comicIndex = (comics as Comic[]).findIndex((c) => c.id === comicId);
  const chapterNum = parseInt(chapterId, 10) || 1;
  const offset =
    ((comicIndex + 1) * 3 + chapterNum * 2) % comicPanels.length;
  const count = 7;
  const result: string[] = [];
  for (let i = 0; i < count; i += 1) {
    result.push(comicPanels[(offset + i) % comicPanels.length]);
  }
  return result;
}

export interface FilterOptions {
  genre?: string;
  region?: string;
  status?: string;
  keyword?: string;
  sort?: string;
}

export function filterComics(options: FilterOptions): Comic[] {
  const { genre, region, status, keyword, sort } = options;
  const kw = (keyword || "").trim().toLowerCase();

  let list = (comics as Comic[]).filter((comic) => {
    if (genre && genre !== "全部" && !comic.genres.includes(genre)) return false;
    if (region && region !== "全部" && comic.region !== region) return false;
    if (status && status !== "全部" && comic.status !== status) return false;
    if (kw && !comic.title.toLowerCase().includes(kw)) return false;
    return true;
  });

  if (sort === "popular") {
    list = [...list].sort((a, b) => b.views - a.views);
  } else if (sort === "alpha") {
    list = [...list].sort((a, b) => a.title.localeCompare(b.title, "zh-Hans-CN"));
  } else {
    list = [...list].sort(
      (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
    );
  }

  return list;
}

export function getRelatedComics(comic: Comic, limit = 6): Comic[] {
  return (comics as Comic[])
    .filter(
      (item) =>
        item.id !== comic.id &&
        item.genres.some((g) => comic.genres.includes(g))
    )
    .slice(0, limit);
}

export function getHotComics(limit = 8): Comic[] {
  return [...(comics as Comic[])]
    .sort((a, b) => b.views - a.views)
    .slice(0, limit);
}

export function getLatestComics(limit = 8): Comic[] {
  return [...(comics as Comic[])]
    .sort(
      (a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
    )
    .slice(0, limit);
}

export function formatDate(date: string): string {
  return date.replace(/-/g, "/");
}